import { pipe } from 'ramda'

import { PurchaseConditionPrice } from '../../typings/product'

const removePurchaseConditionsWithSamePriceOfSameSku = (
  purchaseConditionsPrices: PurchaseConditionPrice[]
) => {
  return purchaseConditionsPrices.reduce((acc, current) => {
    const foundItemWithSamePrice = acc.some(
      (item) =>
        item.id === current.id &&
        item.price === current.price &&
        item.listPrice === current.listPrice
    )

    if (foundItemWithSamePrice) {
      return acc
    }

    return [...acc, current]
  }, [] as PurchaseConditionPrice[])
}

const getPurchaseConditionsPricesPrioritizingTakeAway = (
  purchaseConditionsPrices: PurchaseConditionPrice[]
) => {
  const productTakeAwayConditionsPrices = purchaseConditionsPrices.filter(
    (productPurchaseConditionsPrice) =>
      productPurchaseConditionsPrice.deliveryChannels.includes('take-away')
  )

  return productTakeAwayConditionsPrices.length
    ? productTakeAwayConditionsPrices
    : purchaseConditionsPrices
}

export const getPrioritizedPurchaseConditionsPrices = pipe(
  getPurchaseConditionsPricesPrioritizingTakeAway,
  removePurchaseConditionsWithSamePriceOfSameSku
)
